var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "container mb-4" },
      [
        _c("h2", { staticClass: "k-h-secondary" }, [
          _vm._v("Komentáře (" + _vm._s(_vm.commentsCount || 0) + ")")
        ]),
        _vm._v(" "),
        _c("document-comment-form", {
          ref: "commentForm",
          attrs: { url: _vm.submitUrl, method: _vm.submitMethod },
          on: { commentAdded: _vm.getDataAndScroll }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container mb-3" },
      [
        _c(
          "transition-group",
          { attrs: { name: "list-complete", tag: "div" } },
          [
            _vm._l(_vm.comments, function(comment) {
              return [
                _c(
                  "div",
                  {
                    key: comment.id,
                    ref: "comment-" + comment.id,
                    refInFor: true,
                    staticClass: "k-panel k-panel--grid mb-3"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "k-panel__body--3-4 k-border-right" },
                      [
                        _c("div", { staticClass: "k-panel__body " }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(comment.content) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "k-panel__footer justify-content-between align-items-center"
                          },
                          [
                            _c("div", { staticClass: "k-panel__footer-btn" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "k-action mr-3",
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.commentForm.reactOnComment(
                                        comment
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        role: "img",
                                        width: "12",
                                        height: "11"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          fill: "currentColor",
                                          "xlink:href":
                                            "/images/spritesheet.svg#reply"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                                    Reagovat\n                                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "k-action",
                                  class: [
                                    {
                                      "k-action--disabled":
                                        comment.like_url === null
                                    }
                                  ],
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      return _vm.likeComment(comment)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        role: "img",
                                        width: "12",
                                        height: "11"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          fill: "currentColor",
                                          "xlink:href":
                                            "/images/spritesheet.svg#like"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                                    Poděkovat autorovi (" +
                                      _vm._s(comment.likes_count) +
                                      ")\n                                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            comment.delete_url !== null
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex",
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteComment(comment)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          role: "img",
                                          width: "12",
                                          height: "11"
                                        }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            fill: "currentColor",
                                            "xlink:href":
                                              "/images/spritesheet.svg#add"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                                Odstranit komentář\n                            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "k-panel__body k-panel__body--1-4 border-bottom-0"
                      },
                      [
                        _c("div", { staticClass: "k-user-contact" }, [
                          _c("div", { staticClass: "k-user-contact__image" }, [
                            _c("img", { attrs: { src: comment.user.prev_url } })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "k-user-contact__meta" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  title: comment.user.name,
                                  href: comment.user.detail_url
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "k-user-contact__name" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(comment.user.name) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "k-user-contact__date" }, [
                              _vm._v(
                                "\n                                    Vloženo: " +
                                  _vm._s(comment.created_at) +
                                  "\n                                "
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(comment.reactions, function(reaction) {
                  return _c(
                    "div",
                    {
                      key: reaction.id,
                      ref: "comment-" + reaction.id,
                      refInFor: true,
                      staticClass:
                        "k-panel k-panel--grid mb-3 k-panel--loffset-1"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "k-panel__body--3-4-fluid k-border-right"
                        },
                        [
                          _c("div", { staticClass: "k-panel__body " }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(reaction.content) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "k-panel__footer justify-content-between align-items-center"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "k-panel__footer-btn" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "k-action mr-3",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.commentForm.reactOnComment(
                                            reaction
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            role: "img",
                                            width: "12",
                                            height: "11"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              fill: "currentColor",
                                              "xlink:href":
                                                "/images/spritesheet.svg#reply"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                    Reagovat\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "k-action",
                                      class: [
                                        {
                                          "k-action--disabled":
                                            reaction.like_url === null
                                        }
                                      ],
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.likeComment(reaction)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            role: "img",
                                            width: "12",
                                            height: "11"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              fill: "currentColor",
                                              "xlink:href":
                                                "/images/spritesheet.svg#like"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                    Poděkovat autorovi (" +
                                          _vm._s(reaction.likes_count) +
                                          ")\n                                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              reaction.delete_url !== null
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteComment(reaction)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            role: "img",
                                            width: "12",
                                            height: "11"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              fill: "currentColor",
                                              "xlink:href":
                                                "/images/spritesheet.svg#add"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                Odstranit komentář\n                            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "k-panel__body k-panel__body--1-4-fix border-bottom-0"
                        },
                        [
                          _c("div", { staticClass: "k-user-contact" }, [
                            _c(
                              "div",
                              { staticClass: "k-user-contact__image" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: reaction.user.prev_url,
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "k-user-contact__meta" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    title: reaction.user.name,
                                    href: reaction.user.detail_url
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "k-user-contact__name" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(reaction.user.name) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "k-user-contact__date" },
                                [
                                  _vm._v(
                                    "\n                                    Vloženo: " +
                                      _vm._s(reaction.created_at) +
                                      "\n                                "
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                })
              ]
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }